import { createStore } from 'idb-keyval';

export const syntheticStore = createStore('synthetic-db', 'synthetic-store');
export const rawStore = createStore('raw-db', 'raw-store');
export const stackStore = createStore('stack-db', 'stack-store');